import React, { useEffect, useState } from "react";
import Images from "../../assets/images/index";
import Icons from "../../assets/icons/index";
import { CreateOrder, getCountryStateCityData, getCountryStateCityList, checkCoupons, getcoupons, getOrder, getSubscriptionDetail, getSubscriptionList, preSubmitPackage, submitPackage } from "../../restApi/api";
import { decrypt } from "../../utils/crypto";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import Modal from "react-bootstrap/Modal";
import Toggle from "react-toggle"
import { authorizationCheck } from "../../utils/logout";
import Loader from "../common/Loader/Loader";
import { useQuery } from "@apollo/client";
import { Package_detail_Api } from "../../gql/queries";
import SomethingWentWrong from "../common/NoDataFound/SomethingWentWrong";
import ConnectionError from "../common/NoDataFound/ConnectionError";
import { trackEvent } from "../../../src/utils/moengageUserSetup";
// import Razorpay from 'razorpay';

const INITIAL_STATE = {
    colonyArea: '',
    city: '',
    country: '',
    flateNumber: '',
    landmark: '',
    pincode: '',
    state: '',
    shippingcolonyArea: '',
    shippingcity: '',
    shippingcountry: '',
    shippingflateNumber: '',
    shippinglandmark: '',
    shippingpincode: '',
    shippingstate: '',
};
export default function SubscriptionPlan() {
    function loadScript(src) {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    }

    let { id } = useParams()
    const location = useLocation();
    const navigate = useNavigate();
    let [loader, setloader] = useState(false)
    const [orderShow, setOrder] = useState(false);
    const orderInfo = () => setOrder(true);
    const orderHide = () => setOrder(false);
    const [courseShowData, setcourseShow] = useState(false);
    const courseInfo = () => setcourseShow(true);
    const courseHide = () => setcourseShow(false);
    const [country, setCountry] = useState(null);
    const [shipcountry, setshipCountry] = useState(null);
    let [coupon, setCoupon] = useState('');
    const [state, setState] = useState(null);
    const [city, setCity] = useState(null);
    const [shipstate, setshipState] = useState(null);
    const [shipcity, setshipCity] = useState(null);
    const [course, setCourse] = useState(JSON.parse(decrypt(localStorage.getItem('profileDetails'))));
    const [preSubscription, setPreSubscription] = useState();
    const [getProfileDetails, profileDetails] = useState(INITIAL_STATE);
    const [countryId, setcountryId] = useState(null);
    const [shipcountryId, setshipCountryId] = useState(null);
    const [stateId, setStateId] = useState(null);
    const [cityId, setCityId] = useState(null);
    const [shipstateId, setshipStateId] = useState(null);
    const [shipcityId, setshipCityId] = useState(null);
    const [ind, setIndex] = useState(0);
    let [validity, setValidity] = useState({});
    let [packages, setPackage] = useState(false);
    let [notes, setNotes] = useState(false);
    let [vibes, setVibes] = useState(false);
    const [TotalAmount, setAmount] = useState(0)
    const [Price, setPrice] = useState(0)
    const [discountedPrice, setDiscountedPrice] = useState(0)
    const [notePriceshow, setNotePrice] = useState(0)
    const [pendrivePriceshow, setPendrivePrice] = useState(0)
    const [redeemshow, setredeem] = useState(0)
    const [couponshow, setcouponshow] = useState(0)
    let [paymentDetail, setpaymentDetail] = useState();
    const [packagekey, setpackagekey] = useState(1);
    const [Checkedbox, setCheckbox] = useState(false);
    const [redeemShow, setredeemShow] = useState(false);
    const [isShippingRequired, setisShippingRequired] = useState(false);
    let [count, setCount] = useState(0);
    let [discountPercentage, setdiscountPercentage] = useState(0)
    const [priceAfterCoupon, setPriceAfterCoupon] = useState(0)
    const [disable, setDisable] = useState(false)
    let Shippingcountry = ''
    let Billingcity = ''
    let Billingstate = ''
    let BillingCountry = ''
    let Shippingstate = ''
    let Shippingcity = ''
    let index = 0
    let totalprice = 0
    let packagePrice = 0
    let NotesPrice = 0
    let PendrivePrice = 0
    let redeem = 0
    let couponPrice = 0
    let showToastm = true

    // let discountPercentage = 0
    let isShip = false;
    let isBilling = true;
    // let isShippingRequired = false
    let isBillingRequired = false
    const showToast = (message) => {
        toast.success(message);
    };

    const showToastError = (message) => {
        toast.error(message);
    };
    const makeApiCall = () => {
        const data = {
            "orderId": paymentDetail?.notes?.orderId
        }
        getOrder(data)
            .then(response => {
                return response.json()
            })
            .then(data => {
                if (data.success == true) {
                    trackEvent("packageSuccess", { "package_id": query1?.data?.listPackagesForApp[0]?._id, "package_name": query1?.data?.listPackagesForApp[0]?.title })

                    setloader(false)
                    if (data.data.transactionStatus == 'COMPLETED') {
                        navigate(`/success/${query1?.data?.listPackagesForApp[0]?.title}/${validity?.validityTitle}`)
                    }
                    else if (data.data.transactionStatus == 'PENDING' || data.data.transactionStatus == 'INITIATED') {
                        var intervalId
                        if (count < 1) {
                            makeApiCall()
                            count = count + 1
                            setCount(count + 1)
                        } else {
                            intervalId = setInterval(makeApiCall, 1000);
                            clearInterval(intervalId); // Stop the interval
                            navigate('/pending')
                        }
                    }
                    else {
                        navigate('/error')

                    }
                }

            }).catch((error) => {
                setloader(false)
                showToastError("Something went wrong please try agian")
            })
    }

    // const updatecourse= ()=>{
    //     navigate('/account/editProfile')
    // }

    // const home =()=>{
    //     navigate('/videolayer')
    //     window.location.reload()
    // }


    // const subscriptionList = async () => {
    //     let data = {
    //         packageId: id
    //     }
    //     await getSubscriptionDetail(data)
    //         .then(response => {
    //             return response.json()
    //         })
    //         .then(data => {
    //             setloader(false)
    //             let req = JSON.parse(decrypt(data))
    //             if (req.data.code == 1) {
    //                 setSubscription(req.data.result)
    //                 setPackage(true)
    //                 index = 0
    //                 setIndex(0)
    //                 setValidity(req?.data?.result?.validity[0])
    //                 calculatePrice(req?.data?.result?.validity[0])
    //             }
    //             else if (req.data.code == 402) {
    //                 authorizationCheck(navigate)
    //             }
    //         }).catch(err => {
    //             setloader(false)
    //         })
    // }
    const calculatePrice = async (validity, disPrice = null, aftPrice = priceAfterCoupon) => {
        // alert(priceAfterCoupon)
        // console.log(validity, 'validity');
        if (disPrice) {
            packagePrice = disPrice
            setPrice(disPrice ? disPrice : priceAfterCoupon)

        } else {
            packagePrice = validity?.discountPrice != 0 ? validity?.discountPrice : validity?.mrp
            // setPrice(priceAfterCoupon ? priceAfterCoupon : packagePrice)
            setPrice(aftPrice || packagePrice)
        }
        if (notes == true && validity?.withNotes) {
            NotesPrice = validity?.notes?.notesDiscount ? validity?.notes?.notesDiscount : validity?.notes?.notesPrice
            setNotePrice(NotesPrice)
        }
        else {
            NotesPrice = 0
            setNotePrice(NotesPrice)
        }
        if (vibes == true && validity?.withPenDrive) {
            PendrivePrice = validity?.penDrive?.penDriveDiscount ? validity?.penDrive?.penDriveDiscount : validity?.penDrive?.penDrivePrice
            setPendrivePrice(PendrivePrice)
        }
        else {
            PendrivePrice = 0
            setPendrivePrice(PendrivePrice)
        }
        if (discountPercentage != 0) {
            // couponPrice = (packagePrice * discountPercentage) / 100
            couponPrice = validity?.mrp - (aftPrice ? aftPrice : disPrice)

            setcouponshow(couponPrice)
            // packagePrice = packagePrice - couponPrice
            if (disPrice) {
                totalprice = disPrice + NotesPrice + PendrivePrice
            } else {
                packagePrice = aftPrice ? aftPrice : packagePrice - disPrice
                totalprice = packagePrice + NotesPrice + PendrivePrice - redeem
            }
            // setredeem(redeem)
            setAmount((totalprice).toFixed(2))
        }
        else {
            discountPercentage = 0
            couponPrice = 0
            setcouponshow(couponPrice)
            totalprice = (packagePrice + NotesPrice + PendrivePrice) - redeem
            // setredeem(redeem)
            setAmount((totalprice).toFixed(2))
        }

        if (disPrice || aftPrice) {
            setDiscountedPrice(validity?.mrp - (disPrice ? disPrice : aftPrice))
            // setdiscountPercentage(validity?.mrp - priceAfterCoupon)
        } else {
            setDiscountedPrice(validity?.discountPrice ? (validity?.mrp - (validity?.discountPrice ? validity?.discountPrice : 0)) : 0)
        }
    }
    const selectShipCountry = async (slctCountry) => {
        profileDetails({
            ...getProfileDetails,
            shippingcountry: slctCountry ? slctCountry.target.value : shipcountryId
        })
        const data = {
            "country": slctCountry ? slctCountry.target.value : shipcountryId,
            "state": "",
            "city": "",
            "courses": course?.preparingFor
        }
        await getCountryStateCityList(data)
            .then(response => {
                return response.json()
            })
            .then(data => {
                if (data.data.result?.states) {
                    setshipState(data)
                    setshipCity(null)
                    return
                }
                setshipState(null)
                setshipCity(null)
                return
            })
    }

    const selectShipState = async (slctState) => {
        profileDetails({
            ...getProfileDetails,
            shippingstate: slctState ? slctState.target.value : shipstateId
        })
        const data = {
            "country": "",
            "state": slctState ? slctState.target.value : shipstateId,
            "city": "",
            "courses": course?.preparingFor
        }
        await getCountryStateCityList(data)
            .then(response => {
                return response.json()
            })
            .then(data => {
                if (data.data.result?.city) {
                    setshipCity(data)
                    return
                }
                setshipCity(null)
                return
            })
    }
    const selectShipCity = async (slctCity) => {
        profileDetails({
            ...getProfileDetails,
            shippingcity: slctCity ? slctCity.target.value : shipcityId
        })
        const data = {
            "country": "",
            "state": "",
            "city": slctCity ? slctCity.target.value : shipcityId,
            "courses": course?.preparingFor
        }
        await getCountryStateCityList(data)
            .then(response => {
                return response.json()
            })
            .then(data => {

            })
    }
    const getCountry = async () => {
        const data = {
            "country": "",
            "state": "",
            "city": "",
            "courses": course?.preparingFor
        }
        await getCountryStateCityData(data)
            .then(response => {
                return response.json()
            })
            .then(data => {
                setCountry(data)
                setshipCountry(data)
                setState('')
                setCity('')
                setshipCity('')
                setshipState('')

            }).catch((error) => {
            })
    }
    let couponEnter = (e) => {
        coupon = (e.target.value).trimStart()
        setCoupon((e.target.value).trimStart())
    }

    const selectCountry = async (slctCountry) => {
        profileDetails({
            ...getProfileDetails,
            country: slctCountry ? slctCountry.target.value : countryId
        })
        const data = {
            "country": slctCountry ? slctCountry.target.value : countryId,
            "state": "",
            "city": "",
            "courses": course?.preparingFor
        }
        await getCountryStateCityList(data)
            .then(response => {
                return response.json()
            })
            .then(data => {                // setStateId(data.data.result.states[0]._id)
                if (data.data.result?.states) {
                    setState(data)
                    setCity(null)
                    return
                }
                setState(null)
                setCity(null)
                return
            })
    }

    const selectState = async (slctState) => {
        profileDetails({
            ...getProfileDetails,
            state: slctState ? slctState.target.value : stateId
        })
        const data = {
            "country": "",
            "state": slctState ? slctState.target.value : stateId,
            "city": "",
            "courses": course?.preparingFor
        }
        await getCountryStateCityList(data)
            .then(response => {
                return response.json()
            })
            .then(data => {
                if (data.data.result?.city) {
                    setCity(data)
                    return
                }
                setCity(null)
                return
            })
        // setCityId(data.data.result.city[0]._id)
    }
    const selectCity = async (slctCity) => {
        profileDetails({
            ...getProfileDetails,
            city: slctCity ? slctCity.target.value : cityId
        })
        const data = {
            "country": "",
            "state": "",
            "city": slctCity ? slctCity.target.value : cityId,
            "courses": course?.preparingFor
        }
        await getCountryStateCityList(data)
            .then(response => {
                return response.json()
            })
            .then(data => {

            })
    }
    const query1 = useQuery(Package_detail_Api, {
        variables: {
            "packageId": id,
            "packageType": 'SUBSCRIPTION'
        },
        fetchPolicy: 'network-only',
        onCompleted: (data) => {
            if (data?.listPackagesForApp?.at(0)?.title) {
                trackEvent("viewPackageDetail", { "package_id": id, "package_name": data?.listPackagesForApp?.at(0)?.title })
            }
        }
    });

    useEffect(() => {
        getCountry()
    }, []);
    useEffect(() => {
        countryId && selectCountry()
    }, [countryId])

    useEffect(() => {
        stateId && selectState()
    }, [stateId])

    useEffect(() => {
        cityId && selectCity()
    }, [cityId])
    useEffect(() => {
        shipcountryId && selectShipCountry()
    }, [shipcountryId])
    useEffect(() => {
        shipstateId && selectShipState()
    }, [shipstateId])

    useEffect(() => {
        shipcityId && selectShipCity()
    }, [shipcityId])
    useEffect(() => {
        packages = true
        setPackage(true)
        index = 0
        setIndex(0)
        // console.log(query1.data,'package details');
        validity = query1.data?.listPackagesForApp[0]?.validity[0]
        setValidity(query1.data?.listPackagesForApp[0]?.validity[0])
        calculatePrice(query1.data?.listPackagesForApp[0]?.validity[0])
        setisShippingRequired(query1.data?.listPackagesForApp[0]?.isAddressMandatory ? true : false)
    }, [query1?.data]);
    if (query1.loading) return (<><Loader /></>)
    if (query1.error) {
        if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'UNAUTHENTICATED')) {
            authorizationCheck(navigate)
        }
        else if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'INTERNAL_SERVER_ERROR')) {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <SomethingWentWrong pathName={location.pathname} />
                    </div>
                </div>
            </>)
        }
        else {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <ConnectionError pathName={location.pathname} />
                    </div>
                </div>
            </>)
        }
        console.log(query1.error)
    }
    const choosePackage = (e, i, ob) => {
        setValidity(ob)
        setPackage(e.target.checked)
        index = i
        setIndex(i)
        discountPercentage = 0
        setdiscountPercentage(0)
        setpackagekey(1)
        setCoupon('')
        calculatePrice(ob)

    }
    const note = (e) => {
        notes = e.target.checked
        setNotes(e.target.checked)
        calculatePrice(validity)
    }
    const vibe = (e) => {
        vibes = e.target.checked
        setVibes(e.target.checked)
        calculatePrice(validity)
    }
    const handleInputChange = function (fieldValue, fieldName) {
        profileDetails({ ...getProfileDetails, [fieldName]: fieldValue })
    }

    const RemoveCoupon = () => {
        setPriceAfterCoupon(0)
        if (coupon == '') {
            setpackagekey(2)
            setCoupon('')
            discountPercentage = 0
            setdiscountPercentage(0)
            calculatePrice(validity, null, 0)
        }
        setCoupon('')
        setpackagekey(1)
        discountPercentage = 0
        setdiscountPercentage(0)
        calculatePrice(validity, null, 0)
        if (showToastm)
            showToastError('Coupon Removed Successful')
    }

    const addCoupon = async () => {
        setpackagekey(2)
        if (coupon == '' || coupon == undefined || coupon == null) {
            discountPercentage = 0
            setdiscountPercentage(0)
            calculatePrice(validity)
            setpackagekey(1)
            showToastError('Please Apply Any Coupon')
            return
            //  this.notificationService.show('Please Apply Any Coupon')
        }
        const data = {
            couponCode: coupon,
            packageId: query1.data?.listPackagesForApp[0]?._id,
            validityId: validity?._id,
        }

        // const d = {
        //     packageId: "5e2d2daa573d7a069feb78ab",
        //     validityId: "5ee21401de5ae11bfef09210",
        //     couponCode: "ANMO69"
        // }
        // await getcoupons(data)
        //     .then(response => {
        //         return response.json()
        //     })
        //     .then(data => {
        //         let req = JSON.parse(decrypt(data))
        //         if (req.data.code == 1) {
        //             showToast(req.data.message)
        //             discountPercentage = req.data?.result?.discountPercentage
        //             setdiscountPercentage(req.data?.result?.discountPercentage)
        //             calculatePrice(validity)
        //             setpackagekey(2)
        //             setloader(false)
        //         }
        //         else {
        //             showToastError(req.data.message)
        //             setloader(false)
        //         }
        //     })


        await checkCoupons(data)
            .then(response => {
                return response.json()
            })
            .then(async data => {
                // console.log(data, 'coupon data');
                // let req = JSON.parse(decrypt(data))
                let req = data
                console.log(data, "coupon data");
                if (req.statusCode == 200) {
                    await setPriceAfterCoupon(req.data?.packageDiscounts[0]?.discountedPrice)
                    showToast("Coupon Applied successfully")
                    discountPercentage = req.data?.packageDiscounts[0]?.discountedPrice
                    // discountPercentage = req.data?.result?.discountPercentage
                    setdiscountPercentage(1)
                    calculatePrice(validity, req.data?.packageDiscounts[0]?.discountedPrice)
                    setpackagekey(2)
                    setloader(false)
                }
                else {
                    showToastm = false
                    RemoveCoupon()
                    showToastError(req.message)
                    setloader(false)
                }
            })
    }








    const onSubmit = async (e) =>   // to submit  the form
    {
        trackEvent("buyNow", { "package_id": query1?.data?.listPackagesForApp[0]?._id, "package_name": query1?.data?.listPackagesForApp[0]?.title })
        e.preventDefault();
        if (!course?.collegeName) {
            showToastError('Please update your college details from the profile section')
            return
        }

        // if (getProfileDetails?.country == '' || getProfileDetails?.state == '' || getProfileDetails?.city == '' || getProfileDetails?.colonyArea == '' || getProfileDetails?.pincode == '' || getProfileDetails?.flateNumber == '') {
        //     isBilling = true;
        // } else {
        //     isBilling = true;
        // }
        // if (getProfileDetails?.shippingcountry == '' || getProfileDetails?.shippingstate == '' || getProfileDetails?.shippingcity == '' || getProfileDetails?.shippingcolonyArea == '' || getProfileDetails?.shippingpincode == '' || getProfileDetails?.shippingflateNumber == '') {
        //     isShip = false;
        // } else {
        //     isShip = true;
        //     // this.notificationService.show('Please fill all mandatory fields in Shipping Address')
        // }
        // alert(isBilling)
        if (isBilling == true) {
            // if ((notes == true || vibes == true) && isShip == true) {
            //     if (getProfileDetails?.country != '') {
            //         country?.data?.result?.countries?.map((obj) => {
            //             if (obj._id == getProfileDetails?.country) {
            //                 BillingCountry = (obj.title)
            //             }
            //         })
            //     }
            //     if (getProfileDetails?.state != '') {
            //         state?.data?.result?.states?.map((obj) => {
            //             if (obj._id == getProfileDetails?.state) {
            //                 Billingstate = (obj.title)
            //             }
            //         })
            //     }
            //     if (getProfileDetails?.city != '') {
            //         city?.data?.result?.city?.map((obj) => {
            //             if (obj._id == getProfileDetails?.city) {
            //                 Billingcity = (obj.title)
            //             }
            //         })
            //     }
            //     if (getProfileDetails?.shippingcountry != '') {
            //         shipcountry?.data?.result?.countries?.map((obj) => {
            //             if (obj._id == getProfileDetails?.shippingcountry) {
            //                 Shippingcountry = (obj.title)
            //             }
            //         })

            //     }
            //     if (getProfileDetails?.shippingstate != '') {
            //         shipstate?.data?.result?.states?.map((obj) => {
            //             if (obj._id == getProfileDetails?.shippingstate) {
            //                 Shippingstate = (obj.title)
            //             }
            //         })
            //     }
            //     if (getProfileDetails?.shippingcity != '') {
            //         shipcity?.data?.result?.city?.map((obj) => {
            //             if (obj._id == getProfileDetails?.shippingcity) {
            //                 Shippingcity = (obj.title)
            //             }
            //         })
            //     }
            //     const data = {
            //         "isBuyWithAddones": {
            //             "withNotes": notes,
            //             "withPenDrive": vibes
            //         },
            //         "isAssignedPackageByAdmin": false,
            //         "paymentStatus": false,
            //         "packageType": 1,
            //         "title": query1?.data?.listPackagesForApp[0].title,
            //         "amount": TotalAmount * 100,
            //         "isSpecialDatePackage": validity?.specialDate != null ? true : false,
            //         "capture": "0",
            //         "coinDiscount": redeemshow,
            //         "coinUse": redeemshow,
            //         "couponName": coupon != undefined ? coupon : '',
            //         "couponAmount": couponshow,
            //         "currency": "INR",
            //         "packageId": query1.data?.listPackagesForApp[0]?._id,
            //         "packageType": 1,
            //         "boughtWithNotes": notes,
            //         "boughtWithVibe": vibes,
            //         "purchaseType": "SUBSCRIPTION",
            //         "validityId": validity?._id,
            //         "billingAddress": {
            //             "colonyArea": getProfileDetails?.colonyArea,
            //             "city": Billingcity != undefined ? Billingcity : '',
            //             "country": BillingCountry != undefined ? BillingCountry : '',
            //             "flatNumber": getProfileDetails?.flateNumber,
            //             "landmark": getProfileDetails?.landmark,
            //             "pincode": getProfileDetails?.pincode,
            //             "state": Billingstate != undefined ? Billingstate : '',
            //             "fullAddress": getProfileDetails?.flateNumber + "," + getProfileDetails?.colonyArea + "," + getProfileDetails?.landmark + "," + Billingcity + "," + Billingstate + "," + getProfileDetails?.pincode,
            //         },
            //         "shippingAddress": {
            //             "colonyArea": getProfileDetails?.shippingcolonyArea,
            //             "city": Shippingcity != undefined ? Shippingcity : '',
            //             "country": Shippingcountry != undefined ? Shippingcountry : '',
            //             "flatNumber": getProfileDetails?.shippingflateNumber,
            //             "landmark": getProfileDetails?.shippinglandmark,
            //             "pincode": getProfileDetails?.shippingpincode,
            //             "state": Shippingstate != undefined ? Shippingstate : '',
            //             "fullAddress": getProfileDetails?.shippingflateNumber + "," + getProfileDetails?.shippingcolonyArea + "," + getProfileDetails?.shippinglandmark + "," + Shippingcity + "," + Shippingstate + "," + getProfileDetails?.shippingpincode,
            //         },
            //     }
            //     setloader(true)
            //     await CreateOrder(data)
            //         .then(response => {
            //             return response.json()
            //         })
            //         .then((data) => {
            //             setloader(false)
            //             if (data.success == true) {
            //                 paymentDetail = data?.data
            //                 setpaymentDetail(data.data)
            //                 razorpayDetails(e)
            //             }
            //             else if (data.success == false) {
            //                 showToastError(data.message)
            //             }
            //         }).catch((err) => {
            //             console.log(err)
            //             setloader(false)
            //             showToastError("Something went wrong please try again")
            //         })
            // } else {

            if ((isShippingRequired || (notes == true || vibes == true) && (validity.withNotes == true || validity.withPenDrive == true)) && ((getProfileDetails.shippingcolonyArea == "" || getProfileDetails.shippingcity == "" || getProfileDetails.shippingpincode == "" || getProfileDetails.shippingflateNumber == ""))) {

                // isShip = false;
                showToastError('Please fill all details in  shipping address')
                return

            }
            else {
                if (getProfileDetails?.country != '') {
                    country?.data?.result?.countries?.map((obj) => {
                        if (obj._id == getProfileDetails?.country) {
                            BillingCountry = (obj.title)
                        }
                    })
                }
                if (getProfileDetails?.state != '') {
                    state?.data?.result?.states?.map((obj) => {
                        if (obj._id == getProfileDetails?.state) {
                            Billingstate = (obj.title)
                        }
                    })
                }
                if (getProfileDetails?.city != '') {
                    city?.data?.result?.city?.map((obj) => {
                        if (obj._id == getProfileDetails?.city) {
                            Billingcity = (obj.title)
                        }
                    })
                }
                if (getProfileDetails?.shippingcountry != '') {
                    shipcountry?.data?.result?.countries?.map((obj) => {
                        if (obj._id == getProfileDetails?.shippingcountry) {
                            Shippingcountry = (obj.title)
                        }
                    })

                }
                if (getProfileDetails?.shippingstate != '') {
                    shipstate?.data?.result?.states?.map((obj) => {
                        if (obj._id == getProfileDetails?.shippingstate) {
                            Shippingstate = (obj.title)
                        }
                    })
                }
                if (getProfileDetails?.shippingcity != '') {
                    shipcity?.data?.result?.city?.map((obj) => {
                        if (obj._id == getProfileDetails?.shippingcity) {
                            Shippingcity = (obj.title)
                        }
                    })
                }
                const data = {
                    "isBuyWithAddones": {
                        "withNotes": notes,
                        "withPenDrive": vibes
                    },
                    "isAssignedPackageByAdmin": false,
                    "paymentStatus": false,
                    "couponName": coupon != undefined ? coupon : '',
                    "packageType": 1,
                    "title": query1?.data?.listPackagesForApp[0]?.title,
                    "amount": TotalAmount * 100,
                    "isSpecialDatePackage": validity.specialDate != null ? true : false,
                    "capture": "0",
                    "coinDiscount": redeemshow,
                    "coinUse": redeemshow,
                    "couponAmount": couponshow,
                    "currency": "INR",
                    "packageId": query1?.data?.listPackagesForApp[0]?._id,
                    "packageType": 1,
                    "boughtWithNotes": notes,
                    "boughtWithVibe": vibes,
                    "purchaseType": "SUBSCRIPTION",
                    "validityId": validity?._id,
                    "billingAddress": {
                        "colonyArea": getProfileDetails?.colonyArea,
                        "city": Billingcity != undefined ? Billingcity : '',
                        "country": BillingCountry != undefined ? BillingCountry : '',
                        "flatNumber": getProfileDetails?.flateNumber,
                        "landmark": getProfileDetails?.landmark,
                        "pincode": getProfileDetails?.pincode,
                        "state": Billingstate != undefined ? Billingstate : '',
                        "fullAddress": getProfileDetails?.flateNumber + "," + getProfileDetails?.colonyArea + "," + getProfileDetails?.landmark + "," + Billingcity + "," + Billingstate + "," + getProfileDetails?.pincode,
                    },
                    "shippingAddress": {
                        "colonyArea": getProfileDetails?.shippingcolonyArea,
                        "city": Shippingcity != undefined ? Shippingcity : '',
                        "country": Shippingcountry != undefined ? Shippingcountry : '',
                        "flatNumber": getProfileDetails?.shippingflateNumber,
                        "landmark": getProfileDetails?.shippinglandmark,
                        "pincode": getProfileDetails?.shippingpincode,
                        "state": Shippingstate != undefined ? Shippingstate : '',
                        "fullAddress": getProfileDetails?.shippingflateNumber + "," + getProfileDetails?.shippingcolonyArea + "," + getProfileDetails?.shippinglandmark + "," + Shippingcity + "," + Shippingstate + "," + getProfileDetails?.shippingpincode,
                    },
                }
                setloader(true)
                await CreateOrder(data)
                    .then(response => {
                        return response.json()
                    })
                    .then((data) => {
                        setloader(false)
                        if (data.success == true) {
                            paymentDetail = data?.data
                            setpaymentDetail(data.data)
                            razorpayDetails(e, data.data)
                        }
                        else if (data.success == false) {
                            showToastError(data.message)
                        }
                    }).catch((err) => {
                        console.log(err)
                        setloader(false)
                        showToastError("Something went wrong please try again")
                    })
                // }
            }
        } else {
            showToastError('Please fill all mandatory fields in billing Address')
        }
    }
    const razorpayDetails = async (e) => {
        e.preventDefault()
        let validitiesObj = JSON.stringify(validity) ? JSON.stringify(validity) : ""
        var notesAddon
        if (validity?.withNotes) {
            notesAddon = {
                "notesAddOn": validity.notes != null ? validity.notes.title + '' + ',' + NotesPrice : "",
            }
        }
        var pendriveAddon
        if (validity?.withPenDrive) {
            pendriveAddon = {
                "penDriveAddOn": validity.penDrive != null ? validity.penDrive.title + '' + ',' + PendrivePrice : ""
            }
        }
        console.log(process.env.REACT_APP_Razorpay_Key, 'REACT_APP_Razorpay_Key')
        var options = {
            "key": process.env.REACT_APP_Razorpay_Key, // Enter the Key ID generated from the Dashboard
            "amount": TotalAmount * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            "currency": "INR",
            "name": "eGurukul",
            "description": course?.name,
            "image": "https://rzp-mobile.s3.amazonaws.com/images/rzp.png",
            "order_id": paymentDetail?.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
            "capture": "0",
            "method": "all",
            "handler": (response) => {
                setloader(false)
                makeApiCall()
            },
            "prefill": {
                "name": course?.name,
                "email": course?.email,
                "contact": course?.mobileNo,
                "method": "All",
                "_[flow]": "intent",
                "upi_app_package_name": "com.phonepe.app",
                "prefill": "preFill"
            },
            // "notes": {
            //     "appOrderId": paymentDetail?.notes?.orderId,
            //     "mobileNo": course?.mobileNo,
            //     "packageDetails": "Package, " + query1.data?.listPackagesForApp[0]?.title + ',' + query1.data?.listPackagesForApp[0]?.packageCode,
            //     "validity": validitiesObj,
            //     "month": validity?.months ? validity?.months : "",
            //     "billingAddress": getProfileDetails?.flateNumber + "," + getProfileDetails?.colonyArea + "," + getProfileDetails?.landmark + "," + Billingcity + "," + Billingstate + "," + getProfileDetails?.pincode,
            //     "shippingAddress": getProfileDetails?.shippingflateNumber + "," + getProfileDetails?.shippingcolonyArea + "," + getProfileDetails?.shippinglandmark + "," + Shippingcity + "," + Shippingstate + "," + getProfileDetails?.shippingpincode,
            //     "college": course?.country + "," + course?.collegeState + ',' + course?.collegeCity + ',' + course?.collegeName,
            //     "invoiceNumber": paymentDetail?.notes?.invoiceNumber,
            //     "couponName": coupon != null ? coupon : '',
            //     ...notesAddon,
            //     ...pendriveAddon
            // },
            "theme": {
                "color": "#3AC3FF",
                "hide_topbar": "true",
                "theme": "theme"
            }
        };
        const res = await loadScript(
            "https://checkout.razorpay.com/v1/checkout.js"
        );
        let razorpay = new window.Razorpay(options);
        razorpay.open();
        setloader(false)
        razorpay.on('payment.failed', (response) => {
            setloader(false)
            makeApiCall()
        });
    }
    const checkBoxMark = (e) => {
        if (e.target.checked) {
            isShip = true;
            isBilling = true;
            setshipState(state)
            setshipCity(city)
            profileDetails({
                ...getProfileDetails,
                shippinglandmark: getProfileDetails?.landmark,
                shippingpincode: getProfileDetails?.pincode,
                shippingflateNumber: getProfileDetails?.flateNumber,
                shippingcolonyArea: getProfileDetails?.colonyArea,
                shippingcity: getProfileDetails?.city,
                shippingcountry: getProfileDetails?.country,
                shippingstate: getProfileDetails?.state
            })
            setCheckbox(true)
        }
        else {
            isShip = false;
            isBilling = true;
            setshipState(null)
            setshipCity(null)
            profileDetails({
                ...getProfileDetails,
                shippinglandmark: '',
                shippingpincode: '',
                shippingflateNumber: '',
                shippingcolonyArea: '',
                shippingcity: '',
                shippingcountry: '',
                shippingstate: '',
            })
            setCheckbox(false)
        }
    }
    if (loader) { return (<><Loader /></>) }
    return (
        <>
            <div className="main_wrapper">
                <div className="breadcrumbs">
                    <ul className="breadcrumb">
                        <li className="breadcrumb-item"><a >Home</a></li>
                        <li className="breadcrumb-item active"><a >Subscription</a></li>
                    </ul>
                </div>
                <section className="videoLayer_wrapper subscription_plans_wrapper section_side_padding">
                    <ToastContainer autoClose={500} limit={1} />
                    <div className='row'>
                        <div className="col-lg-8 col-md-7 col-sm-12">
                            <div className="recommended_video_wrapper">
                                <div className="choose_plans_wrapper d-flex align-items-center">
                                    <figure className="arrow">
                                        <Link to={'/package'}>
                                            <img src={Icons.BackArrow} alt="" className="img-fluid" />
                                        </Link>
                                    </figure>
                                    <div className="subscription_ttl">
                                        <h5>{query1.data?.listPackagesForApp[0]?.title}</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="recommended_video_wrapper">
                                <div className="plans_details_wrapper">
                                    <div className="plans_main_ttl">
                                        <h5>Details</h5>
                                    </div>
                                    <ul type="none" className="">
                                        <>
                                            {
                                                query1.data?.listPackagesForApp[0]?.newDescription?.length > 0 ? query1.data?.listPackagesForApp[0]?.newDescription && query1.data?.listPackagesForApp[0]?.newDescription.map(obj => (
                                                    <li>{obj}</li>
                                                )) : <li dangerouslySetInnerHTML={{ __html: query1.data?.listPackagesForApp[0]?.description }}></li>
                                            }
                                        </>

                                    </ul>
                                </div>
                            </div>
                            <div className="recommended_video_wrapper">
                                <div className="plans_details_wrapper">
                                    <div className="plans_main_ttl">
                                        <h5>Choose Package</h5>
                                    </div>
                                    <div className="plans_packages d-flex flex-wrap">
                                        {
                                            query1.data?.listPackagesForApp[0]?.validity && query1.data?.listPackagesForApp[0]?.validity.map((ob, i) => (
                                                <label for={`packageSelected${i}`}>
                                                    <input type="radio" id={`packageSelected${i}`} name="radioName" onClick={(e) => choosePackage(e, i, ob)} hidden />
                                                    <div className={`plans_info ${(packages == true && i == ind) ? 'selected' : ''}`}>
                                                        <span>{ob?.validityTitle}</span>
                                                        <h6>&#8377; {ob?.discountPrice ? ob?.discountPrice : ob?.mrp}</h6>
                                                        {
                                                            ob?.discountPrice !== 0 &&
                                                            <del>&#8377; {ob?.mrp}</del>
                                                        }
                                                    </div>
                                                </label>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                (validity?.withNotes || validity?.withPenDrive) &&
                                <div className="recommended_video_wrapper">
                                    <div className="plans_details_wrapper">
                                        <div className="plans_main_ttl">
                                            <h5>Add-Ons</h5>
                                        </div>
                                        <div className="addon_wrapper">
                                            <div className="row">
                                                {
                                                    // (validity?.withNotes) && query1.data?.listPackagesForApp[0]?.packagePurchased?.boughtWithNotes != validity?.withNotes &&
                                                    (validity?.withNotes) &&
                                                    <div className="col-lg-6 col-md-6 col-sm-12" >
                                                        <label For="addonSelected">
                                                            <input type="checkbox" id="addonSelected" name="addonCheckbox" onClick={(e) => note(e)} hidden />
                                                            <div className={`plans_wrapper ${notes == true ? 'selected' : ''}`}>
                                                                <div className="plans_header d-flex align-items-center">
                                                                    <div className="plans_name">
                                                                        <h6>Notes</h6>
                                                                        <p>Hard Copy</p>
                                                                    </div>
                                                                    <div className="plan_price">
                                                                        <h6>₹{validity?.notes?.notesDiscount != 0 ? validity?.notes?.notesDiscount : validity?.notes?.notesPrice}</h6>
                                                                        {
                                                                            validity?.notes?.notesDiscount != 0 &&
                                                                            <p><del>₹ {validity?.notes?.notesPrice}</del></p>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="plans_body">
                                                                    <div dangerouslySetInnerHTML={{ __html: `${validity?.notes?.description != "undefined" ? validity?.notes?.description : ""}` }}></div>
                                                                </div>
                                                            </div>
                                                        </label>
                                                    </div>
                                                }
                                                {
                                                    // (validity?.withPenDrive) && query1.data?.listPackagesForApp[0]?.packagePurchased?.boughtWithVibe != validity?.withPenDrive &&
                                                    (validity?.withPenDrive) &&
                                                    <div className="col-lg-6 col-md-6 col-sm-12" >
                                                        <label For="vibeSelected">
                                                            <input type="checkbox" id="vibeSelected" name="addonCheckbox" onClick={(e) => vibe(e)} hidden />
                                                            <div className={`plans_wrapper ${vibes === true ? 'selected' : ''}`}>
                                                                <div className="plans_header d-flex align-items-center">
                                                                    <div className="plans_name">
                                                                        <h6>Vibe</h6>
                                                                        <p>View Type 1x</p>
                                                                    </div>
                                                                    <div className="plan_price">
                                                                        <h6>₹{validity?.penDrive && validity?.penDrive?.penDriveDiscount ? validity?.penDrive?.penDriveDiscount : validity?.penDrive?.penDrivePrice}</h6>
                                                                        {
                                                                            validity?.penDrive && validity?.penDrive?.penDriveDiscount != 0 &&
                                                                            <p><del>₹ {validity.penDrive.penDrivePrice}</del></p>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="plans_body">
                                                                    <div dangerouslySetInnerHTML={{ __html: `${validity?.penDrive?.description != "undefined" ? validity?.penDrive?.description : ""}` }} ></div>
                                                                </div>
                                                            </div>
                                                        </label>
                                                    </div>
                                                }
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            }
                            {

                                <div className="recommended_video_wrapper">
                                    <div className="plans_details_wrapper">
                                        <div className="plans_main_ttl">
                                            <h5>Enter Coupon Code</h5>
                                        </div>
                                        <div className="coupon_code">
                                            <div className="coupon_input d-flex align-item-center">
                                                <div className="code">
                                                    {
                                                        packagekey == 1 &&
                                                        <input type="text" className="form-control" placeholder="Write Here" value={coupon} onChange={(e) => couponEnter(e)} />
                                                    }
                                                    {
                                                        packagekey == 2 &&
                                                        <input type="text" className="form-control" placeholder="Write Here" value={coupon} disabled={true} onChange={(e) => couponEnter(e)} />
                                                    }
                                                    <span className="cstm_span_text">Use 'MOLAR' coupon for 16% Discount.</span>

                                                </div>
                                                <div className="apply_btn">
                                                    {packagekey == 1 &&
                                                        <button type="button" className="btn btn_apply" onClick={addCoupon}>Apply <img src={Icons.ArrowBlue} alt="" className="img-fluid" /></button>
                                                    }
                                                    {
                                                        packagekey == 2 &&
                                                        <button type="button" className="btn btn_apply" onClick={RemoveCoupon}>Reset <img src={Icons.ArrowBlue} alt="" className="img-fluid" /></button>
                                                    }
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className="form_submission">
                                <form onSubmit={(e) => { onSubmit(e) }}>
                                    {/* {
                                        isBillingRequired &&
                                        <div className="recommended_video_wrapper">

                                            <div className="plans_details_wrapper">
                                                <div className="plans_main_ttl">
                                                    <h5>Billing Address</h5>
                                                </div>
                                                <div className="billing_address">
                                                    <div className="row">
                                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <input type="text" className="form-control" id="" placeholder="Flat, House No., Building, Apartment*" onChange={(e) => handleInputChange((e.target.value).trimStart(), 'flateNumber')} value={getProfileDetails?.flateNumber} />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <input type="text" className="form-control" id="" placeholder="Area, Colony, Street, Sector, Village*" onChange={(e) => handleInputChange((e.target.value).trimStart(), 'colonyArea')} value={getProfileDetails?.colonyArea} />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <input type="text" className="form-control" id="" placeholder="Landmark" onChange={(e) => handleInputChange((e.target.value).trimStart(), 'landmark')} value={getProfileDetails?.landmark} />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <input type="text" className="form-control" id="" placeholder="Pincode*" onChange={(e) => handleInputChange(((e.target.value).trimStart()).replace(/\D/g, ''), 'pincode')} maxlength="6" value={getProfileDetails?.pincode} />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <select name="" id="" className="form-control" onChange={(event) => selectCountry(event)}>
                                                                    <option value=""  >Select Country</option>
                                                                    {
                                                                        country && country.data.result.countries.map((d, i) => (
                                                                            <option value={d._id} selected={getProfileDetails.country && getProfileDetails.country === d._id} >{d.title}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <select name="" id="" className="form-control" onChange={(event) => selectState(event)}>
                                                                    <option value=""  >Select State</option>
                                                                    {
                                                                        (state != null && state.data) && state.data.result.states.map((d, i) => (
                                                                            <option value={d._id} selected={getProfileDetails.state && getProfileDetails.state === d._id}>{d.title}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <select name="" id="" className="form-control" onChange={(event) => selectCity(event)}>
                                                                    <option value=""  >Select City</option>
                                                                    {
                                                                        (city && city.data) && city.data.result.city.map((d, i) => (
                                                                            <option value={d._id} selected={getProfileDetails.city && getProfileDetails.city === d._id}>{d.title}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    } */}

                                    {
                                        // isShippingRequired || (notes || vibes) && (validity.withNotes || validity.withPenDrive)

                                        (isShippingRequired || (notes == true || vibes == true) && (validity.withNotes == true || validity.withPenDrive == true)) &&
                                        <div className="recommended_video_wrapper">
                                            <div className="plans_details_wrapper">
                                                <div className="plans_main_ttl shipping_address">
                                                    <h5>Shipping Address</h5>
                                                    {/* <div className="custom-control custom-checkbox">
                                                        <input type="checkbox" className="custom-control-input" id="select_ship" name="example1" checked={Checkedbox} onChange={(e) => checkBoxMark(e)} />
                                                        <label className="custom-control-label" for="select_ship">My Shipping address is same as my Billing address</label>
                                                    </div> */}
                                                </div>
                                                {
                                                    // Checkedbox === false &&
                                                    <div className="billing_address">
                                                        <div className="row">
                                                            <div className="col-lg-6 col-md-6 col-sm-12">
                                                                <div className="form-group">
                                                                    <input type="text" className="form-control" id="" placeholder="Flat, House No., Building, Apartment*" onChange={(e) => handleInputChange((e.target.value).trimStart(), 'shippingflateNumber')} value={getProfileDetails?.shippingflateNumber} />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 col-md-6 col-sm-12">
                                                                <div className="form-group">
                                                                    <input type="text" className="form-control" id="" placeholder="Area, Colony, Street, Sector, Village*" onChange={(e) => handleInputChange((e.target.value).trimStart(), 'shippingcolonyArea')} value={getProfileDetails?.shippingcolonyArea} />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-3 col-md-6 col-sm-12">
                                                                <div className="form-group">
                                                                    <input type="text" className="form-control" id="" placeholder="Landmark" onChange={(e) => handleInputChange((e.target.value).trimStart(), 'shippinglandmark')} value={getProfileDetails?.shippinglandmark} />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-3 col-md-6 col-sm-12">
                                                                <div className="form-group">
                                                                    <input type="text" className="form-control" id="" placeholder="Pincode*" maxlength="6" onChange={(e) => handleInputChange(((e.target.value).trimStart()).replace(/\D/g, ''), 'shippingpincode')} value={getProfileDetails?.shippingpincode} />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 col-md-6 col-sm-12">
                                                                <div className="form-group">
                                                                    <select name="" id="" className="form-control" onChange={(event) => selectShipCountry(event)}>
                                                                        <option value="" selected >Select Country</option>
                                                                        {
                                                                            shipcountry && shipcountry.data.result.countries.map((d, i) => (
                                                                                <option value={d._id} selected={getProfileDetails.shippingcountry && getProfileDetails.shippingcountry === d._id}>{d.title}</option>
                                                                            ))
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-3 col-md-6 col-sm-12">
                                                                <div className="form-group">
                                                                    <select name="" id="" className="form-control" onChange={(event) => selectShipState(event)}>
                                                                        <option value="" selected >Select State</option>
                                                                        {
                                                                            (shipstate != null && shipstate.data) && shipstate.data.result.states.map((d, i) => (
                                                                                <option value={d._id} selected={getProfileDetails.shippingstate && getProfileDetails.shippingstate === d._id}>{d.title}</option>
                                                                            ))
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-3 col-md-6 col-sm-12">
                                                                <div className="form-group">
                                                                    <select name="" id="" className="form-control" onChange={(event) => selectShipCity(event)}>
                                                                        <option value="" selected >Select City</option>
                                                                        {
                                                                            (shipcity && shipcity.data) && shipcity.data.result.city.map((d, i) => (
                                                                                <option value={d._id} selected={getProfileDetails.shippingcity && getProfileDetails.shippingcity === d._id}>{d.title}</option>
                                                                            ))
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                    {
                                        (packages == true || vibes == true || notes == true) &&
                                        <div className="recommended_video_wrapper ">
                                            <div className="plan_price d-flex align-items-center justify-content-between" >
                                                <h3>₹ {TotalAmount} <span onClick={orderInfo}>View Details <img src={Icons.OrderDetailInfo} alt="" className="img-fluid" /></span></h3>
                                                {
                                                    // query1.data?.listPackagesForApp[0]?.packagePurchased === null && 
                                                    <button type="submit" className="btn btn_buy">Buy Now</button>
                                                }
                                                {/* {
                                                    query1.data?.listPackagesForApp[0]?.packagePurchased !== null &&
                                                    <button type="button" className="btn btn_buy">Purchased</button>
                                                } */}
                                            </div>
                                        </div>
                                    }
                                </form>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-4 col-sm-12">
                            {/* <div className="videos_wrapper">
                                <div className="buy_packages d-flex align-items-center">
                                    <div className="package_text">
                                        <h6>Buy Package</h6>
                                        <p>Buy Package to unlock content and Start Learning</p>
                                    </div>
                                    <div className="package_img">
                                        <img src={Images.Package} alt="" className="img-fluid"/>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </section>
            </div>
            <Modal
                show={orderShow}
                onHide={orderHide}
                backdrop="static"
                className="detail_modal order_summary"
                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        <h4>Order Summary <span>({query1?.data?.listPackagesForApp[0]?.title})</span></h4>
                        {/* {
                            subscription && subscription.userCoin !== 0 &&
                            <p>You can use 50 coins for this purchase</p>
                        } */}
                        <span className="cross_icon">
                            <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={orderHide} />
                        </span>
                        {/* {
                            subscription && subscription.userCoin !== 0 &&
                            <span className="toggle_wrapper">
                                <Toggle
                                    // id='cheese-status'
                                    onChange={(e) => changeCoin(e)}
                                    defaultChecked={redeemShow}
                                />
                            </span>
                        } */}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="account_option_wrapper">
                        <div className="main_accrodion">
                            <div id="accordion">
                                {
                                    packages &&
                                    <div className="vibe_dropdown_wrapper">
                                        <div className="vibe_header">
                                            <a className="card-link" data-toggle="collapse" href="#collapseThree">
                                                <div className="vibe_plans_hedr d-flex align-items-center justify-content-between">
                                                    <div className="vibe_ttl">
                                                        <h6>Subscription Package</h6>
                                                    </div>
                                                    <div className="vibe_price">
                                                        <span>₹{Price}</span>
                                                    </div>
                                                </div>
                                                <span className="down_arrow">
                                                    <img src={Icons.OrderDropdown} alt="Dropdown" className="img-fluid" />
                                                </span>
                                            </a>
                                        </div>
                                        <div id="collapseThree" className="collapse" data-parent="#accordion">
                                            <div className="price_body">
                                                <ul type="none">
                                                    <li className="d-flex align-items-center justify-content-between">
                                                        <div className="vibe_amount">
                                                            <h6>Original Amount</h6>
                                                        </div>
                                                        <div className="vibe_price">
                                                            <span>₹{validity?.mrp}</span>
                                                        </div>
                                                    </li>
                                                    <li className="d-flex align-items-center justify-content-between">
                                                        <div className="vibe_amount">
                                                            <h6>{discountPercentage ? "Discount" : "Discounted Amount"}</h6>
                                                        </div>
                                                        {/* <div className="vibe_price">
                                                            <span className="green">-₹{validity?.discountPrice !== 0 ? validity?.mrp - validity?.discountPrice : 0}</span>
                                                        </div> */}
                                                        <div className="vibe_price">
                                                            <span className="green">-₹{discountedPrice}</span>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {
                                    vibes && (validity?.withPenDrive) && query1.data?.listPackagesForApp[0]?.packagePurchased?.boughtWithVibe != validity?.withPenDrive &&
                                    <div className="vibe_dropdown_wrapper">
                                        <div className="vibe_header">
                                            <a className="card-link" data-toggle="collapse" href="#collapseOne">
                                                <div className="vibe_plans_hedr d-flex align-items-center justify-content-between">
                                                    <div className="vibe_ttl">
                                                        <h6>Vibe Package</h6>
                                                    </div>
                                                    <div className="vibe_price">
                                                        <span>₹{pendrivePriceshow}</span>
                                                    </div>
                                                </div>
                                                <span className="down_arrow">
                                                    <img src={Icons.OrderDropdown} alt="Dropdown" className="img-fluid" />
                                                </span>
                                            </a>
                                        </div>
                                        <div id="collapseOne" className="collapse show" data-parent="#accordion">
                                            <div className="price_body">
                                                <ul type="none">
                                                    <li className="d-flex align-items-center justify-content-between">
                                                        <div className="vibe_amount">
                                                            <h6>Original Amount</h6>
                                                        </div>
                                                        <div className="vibe_price">
                                                            <span>₹{validity?.penDrive?.penDrivePrice}</span>
                                                        </div>
                                                    </li>
                                                    <li className="d-flex align-items-center justify-content-between">
                                                        <div className="vibe_amount">
                                                            <h6>Discounted Amount</h6>
                                                        </div>
                                                        <div className="vibe_price">
                                                            <span className="green">-₹{validity?.penDrive?.penDrivePrice - validity?.penDrive?.penDriveDiscount}</span>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {
                                    notes && (validity?.withNotes) && query1.data?.listPackagesForApp[0]?.packagePurchased?.boughtWithNotes != validity?.withNotes &&
                                    <div className="vibe_dropdown_wrapper">
                                        <div className="vibe_header">
                                            <a className="card-link" data-toggle="collapse" href="#collapseTwo">
                                                <div className="vibe_plans_hedr d-flex align-items-center justify-content-between">
                                                    <div className="vibe_ttl">
                                                        <h6>Notes Amount</h6>
                                                    </div>
                                                    <div className="vibe_price">
                                                        <span>₹{notePriceshow}</span>
                                                    </div>
                                                </div>
                                                <span className="down_arrow">
                                                    <img src={Icons.OrderDropdown} alt="Dropdown" className="img-fluid" />
                                                </span>
                                            </a>
                                        </div>
                                        <div id="collapseTwo" className="collapse" data-parent="#accordion">
                                            <div className="price_body">
                                                <ul type="none">
                                                    <li className="d-flex align-items-center justify-content-between">
                                                        <div className="vibe_amount">
                                                            <h6>Original Amount</h6>
                                                        </div>
                                                        <div className="vibe_price">
                                                            <span>₹{validity?.notes?.notesPrice}</span>
                                                        </div>
                                                    </li>
                                                    <li className="d-flex align-items-center justify-content-between">
                                                        <div className="vibe_amount">
                                                            <h6>Discounted Amount</h6>
                                                        </div>
                                                        <div className="vibe_price">
                                                            <span className="green">-₹{validity?.notes?.notesPrice - validity?.notes?.notesDiscount}</span>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                }

                            </div>
                        </div>
                        <div className="final_price">
                            <ul type="none">
                                {/* <li className="d-flex align-items-center justify-content-between">
                                    <div className="vibe_amount">
                                        <h6>Coupon Amount</h6>
                                    </div>
                                    <div className="vibe_price">
                                        <span className="green">-₹{couponshow}</span>
                                    </div>
                                </li> */}
                                {/* <li className="d-flex align-items-center justify-content-between">
                                    <div className="vibe_amount">
                                        <h6>Coin Discount</h6>
                                    </div>
                                    <div className="vibe_price">
                                        <span>₹{redeemshow}</span>
                                    </div>
                                </li> */}
                                <li className="d-flex align-items-center justify-content-between">
                                    <div className="vibe_amount">
                                        <h6 className="green">Total Amount</h6>
                                    </div>
                                    {
                                        <div className="vibe_price">
                                            <span className="green">₹ {TotalAmount}</span>
                                        </div>
                                    }
                                </li>
                            </ul>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
        // <Modal
        //     show={courseShowData}
        //     onHide={courseHide}
        //     backdrop="static"
        //     className="detail_modal report_modal proUsers_modal"
        //     centered>
        //     <Modal.Header>
        //         <Modal.Title>
        //             <h4>Course Change</h4>
        //             {/* <div className="cross_icon text-right">
        //                 <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={ProUserHide}/>
        //             </div> */}
        //         </Modal.Title>
        //     </Modal.Header>
        //     <Modal.Body>
        //         {/* <div className="account_option_wrapper"> */}
        //             <div className="account_header text-center">
        //                 <h6>Not a {dataset?.course} student</h6>
        //                 <p>You are a student of {course?.preparingFor}  course. In order to purchase package of this course, you need to change your current course. Click Yes to change your course.</p>
        //             </div>
        //         {/* </div> */}
        //     </Modal.Body>
        //     <Modal.Footer>
        //         <div className="rating_submit">
        //             <button type="button" className="btn btn_theme btn_border" onClick={updatecourse}>Yes</button>
        //             <button type="button" className="btn btn_theme" onClick={home}>No</button>
        //         </div>
        //     </Modal.Footer>
        // </Modal>
    )
}